import { combineEpics } from 'redux-observable';

import contatosEpics from './contatosEpic';
//import chatEpic from './chatEpic';
import loginEpic from './loginEpic';

export default combineEpics(
    loginEpic,
   // chatEpic,
    contatosEpics,
)


// WEBPACK FOOTER //
// ./src/epics/index.js